import { BasicQueryStringUtils } from '@openid/appauth';

export class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input) {
    // https://github.com/openid/AppAuth-JS/issues/92
    return super.parse(input, false);
  }
}
